import { useState } from "react";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import AllData from './components/AllData';
import Countries from './components/Countries';
import Country from "./components/Country";
import GenericFirstLevel from "./components/GenericFirstLevel";
import GenericSecondLevel from "./components/GenericSecondLevel";
import GenericThirdLevel from './components/GenericThirdLevel';
import GenericFourthLevel from './components/GenericFourthLevel';
import Home from './components/Home';
import NotFound from "./components/NotFound";
import CountryView from "./components/CountryView";
import Capitals from "./components/Capitals";
import Continents from "./components/Continents";
import CountriesByContinent from "./components/CountriesByContinent";
import CountriesView from "./components/CountriesView";
import Flags from "./components/Flags";
import CountryFlag from "./components/CountryFlag";
import LargestCountries from "./components/LargestCountries";
import LargestPopulation from "./components/LargestPopulation";
import SmallestCountries from "./components/SmallestCountries";
import SmallestPopulation from "./components/SmallestPopulation";

const App = () => {

  const [isActive, setActive] = useState(false);
  const toggle = () => {
      setActive(!isActive);
  }

  return (
    <BrowserRouter basename="/test/countries">
      <nav className="navbar" role="navigation" aria-label="main navigation">
        <span role="button" className={`navbar-burger burger ${isActive ? "is-active" : ""}`} data-target="navMenu" aria-label="menu" aria-expanded="false" onClick={toggle}>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </span>
        <div className={`navbar-menu ${isActive ? "is-active" : ""}`} onClick={toggle}>
          <div className="navbar-start">
            <Link to="/" className="navbar-item" title="Back to home page">Home</Link>
            <Link to="/view" className="navbar-item" title="Alphabetical list of all countries">Select a country</Link>
            <Link to="/view/Finland" className="navbar-item" title="Shortcut to Finland's data">Finland</Link>
          </div>
          <div className="navbar-end"></div>
        </div>
      </nav>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Home />} />
        <Route path="/all" element={<AllData />} />
        <Route path="/capitals" element={<Capitals />} />
        <Route path="/continents" element={<Continents />} />
        <Route path="/continents/:continent/countries" element={<CountriesByContinent />} /> 
        <Route path="/:country" element={<Country />} />
        <Route path="/flags" element={<Flags />}/>
        <Route path="/:country/:first" element={<GenericFirstLevel />} />
        <Route path="/:country/:first/:second" element={<GenericSecondLevel />} />
        <Route path="/:country/:first/:second/:third" element={<GenericThirdLevel />} />
        <Route path="/:country/:first/:second/:third/:fourth" element={<GenericFourthLevel />} />
        <Route path="/:country/flag" element={<CountryFlag />} />
        <Route path="/countries/largest/area" element={<LargestCountries />} />
        <Route path="/countries/largest/population" element={<LargestPopulation />} />
        <Route path="/countries/smallest/area" element={<SmallestCountries />} />
        <Route path="/countries/smallest/population" element={<SmallestPopulation />} />
        <Route path="/view/*" element={<NotFound />} />
        <Route path="/view" element={<Countries />} />
        <Route path="/view/all" element={<Countries />} />
        <Route path="/view/:country" element={<CountryView />} />
        <Route path="/view/continents/:continent/countries" element={<CountriesView />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App;